import { BLOCKS } from '@contentful/rich-text-types';
import _get from 'lodash/get';
import Image from 'src/components-v2/Media/Image/Image';
import { Contentful, RichTextAssets } from 'src/lib/constants';

const EmbeddedAssetSwitch = ({ asset }) => {
  return {
    [BLOCKS.EMBEDDED_ASSET]: (node) => {
      const assetType = _get(node, Contentful.EMBEDDED_ASSET_CONTENT_TYPE_ID);
      switch (assetType) {
        case RichTextAssets.ASSET: {
          const altText =
            _get(node, 'data.target.fields.description') ||
            _get(node, 'data.target.fields.title');
          return <Image {...asset} src={asset?.imgSrc} alt={altText} />;
        }
        default:
          return null;
      }
    },
  };
};

export default EmbeddedAssetSwitch;
